import { pageSelectorGenerator } from '@test/pageSelectors';

export const PaperCheckoutInstructionsSelectors = pageSelectorGenerator('PaperCheckoutInstructions', ['ContainerElement', 'GotItButton']);
